import * as OPTIONS from './options';
import * as ROLE from './role';
import * as PERMISSION from './permission';
import * as GADAI from './gadai';
import * as CABANG from './cabang';
import * as ANGGOTA from './anggota';
import * as REKENING from './rekening';
import * as VOUCHER from './voucher';
import * as OPERASIONAL_KAS from './operasionalKas';
import * as LELANG_PACKING from './lelangPacking';
import * as LELANG_KIRIM_BALIK from './lelangKirimBalik';

const CONSTANTS = {
  ...OPTIONS,
  ...ROLE,
  ...PERMISSION,
  ...GADAI,
  ...CABANG,
  ...ANGGOTA,
  ...REKENING,
  ...VOUCHER,
  ...OPERASIONAL_KAS,
  ...LELANG_PACKING,
  ...LELANG_KIRIM_BALIK,
};

export default CONSTANTS;
